module.exports = __webpack_public_path__ + "img/CompScope_Space_09.6795af77.png";